import React from 'react'
import { Box } from '@plvs/respawn/features/layout'
import { NxAvatar, NxTypography } from '@playvs-inc/nexus-components'
import { defaultToEmptyString } from '@plvs/utils'
import { makeStyles, useTheme } from '@material-ui/core'
import { Hotstreak } from '@plvs/respawn/features/overlay/matchOverlay/components/Hotstreak'

const AVATAR_SIZE = 250

type MatchOverlayTeamClusterProps = {
  team?: {
    id: string
    avatarUrl?: string | null
    name?: string | null
    school?: {
      name?: string | null
    } | null
  } | null
  showHotstreak?: boolean
}

const useStyles = makeStyles({
  teamName: {
    fontSize: '2.25rem',
  },
  schoolName: {
    fontSize: '1.9rem',
  },
})

export const MatchOverlayTeamCluster: React.FC<
  MatchOverlayTeamClusterProps
> = ({ team, showHotstreak }) => {
  const theme = useTheme()
  const styles = useStyles()

  return (
    <Box
      alignItems="center"
      display="flex"
      flex={0}
      flexDirection="column"
      gridGap={theme.spacing(2)}
      minWidth="450px"
    >
      <Box>
        {showHotstreak && <Hotstreak size="xl" streakLength={100} />}

        <NxAvatar
          avatarHashId={defaultToEmptyString(team?.id)}
          avatarUrl={defaultToEmptyString(team?.avatarUrl)}
          height={AVATAR_SIZE}
          width={AVATAR_SIZE}
        />
      </Box>

      <NxTypography className={styles.teamName} variant="h1">
        {team?.name}
      </NxTypography>
      <NxTypography className={styles.schoolName} variant="h3">
        {team?.school?.name}
      </NxTypography>
    </Box>
  )
}
